import React from 'react';

export default function SummaryCard({ title, value, subtitle, icon: Icon, trend, trendValue, onClick }) {
    return (
        <div className={`summary_card ${onClick ? 'clickable' : ''}`} onClick={onClick}>
            <div className="summary_card_content">
                <div className="summary_card_header">
                    {Icon && (
                        <div className="summary_card_icon">
                            <Icon />
                        </div>
                    )}
                    <div className="summary_card_text">
                        <span className="summary_card_title">{title}</span>
                        <span className="summary_card_value">{value}</span>
                    </div>
                </div>
                {(subtitle || trend) && (
                    <div className="summary_card_footer">
                        {subtitle && <span className="summary_card_subtitle">{subtitle}</span>}
                        {trend && (
                            <span className={`summary_card_trend ${trend}`}>
                                {trend === 'up' ? '↑' : trend === 'down' ? '↓' : ''}
                                {trendValue}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
